import React from 'react';

/**
 * Read-only flag for the legacy Indexing Admin screens (/admin/idx/:tabName).
 *
 * Indexing Admin moved to the new UI (/admin/indexing). IdxAdminLanding wraps
 * its tab content in <IdxAdminReadOnlyProvider value={true}> so every
 * IndexingAdmin component hides/disables its write controls.
 *
 * The default is `false` on purpose: some of these components are also
 * embedded by the indexing workstation (OCEditModal, LocationsField) and by
 * SalesRep/Doctors, which do NOT render through IdxAdminLanding and must keep
 * their write abilities.
 */
const IdxAdminReadOnlyContext = React.createContext(false);

export const IdxAdminReadOnlyProvider = IdxAdminReadOnlyContext.Provider;

export const IdxAdminReadOnlyConsumer = IdxAdminReadOnlyContext.Consumer;

export const useIdxAdminReadOnly = () =>
  React.useContext(IdxAdminReadOnlyContext);

/** Shown in place of a create/edit form reached directly by URL. */
export const IdxAdminViewOnlyNotice = ({ what = 'This form' }) => (
  <div
    style={{
      margin: 16,
      padding: '12px 16px',
      border: '1px solid #ffb74d',
      background: '#fff8e1',
      borderRadius: 4,
      fontSize: 14,
    }}>
    {what} is not available: the legacy Indexing Admin is view-only. Use the new
    app (Admin → Indexing Admin, /admin/indexing) to make changes.
  </div>
);

export default IdxAdminReadOnlyContext;
